/**
 * Flock Health Assistant Page
 *
 * Comprehensive health diagnostic tool for Bridge Club members.
 */
import React from 'react';
import BridgeClubLayout from '../../components/BridgeClub/BridgeClubLayout';
import FlockHealthAssistant from '../../components/BridgeClub/FlockHealthAssistant';

const FlockHealthAssistantPage: React.FC = () => {
  return (
    <BridgeClubLayout>
      <FlockHealthAssistant />
    </BridgeClubLayout>
  );
};

export default FlockHealthAssistantPage;
